import { Suggest, SkyscannerPlace, SkyscannerPlaceType } from 'types';

type TypedSuggest =
  | Suggest.CarsSuggest
  | Suggest.HotelSuggest
  | SkyscannerPlace;

export function mapSuggest(suggest: TypedSuggest, type: Suggest.Type) {
  if (type == Suggest.Type.CAR) {
    return mapCarSuggest(suggest as Suggest.CarsSuggest);
  } else if (type == Suggest.Type.FLIGHT) {
    return mapFlightSuggest(suggest as SkyscannerPlace);
  } else {
    return mapHotelSuggest(suggest as Suggest.HotelSuggest);
  }
}
export function mapHotelSuggest(
  suggest: Suggest.HotelSuggest,
): Suggest.Suggest<Suggest.HotelSuggest> {
  return {
    source: suggest,
    title: suggest.title,
    subtitle: suggest.sub_title,
    locationType: parseLocationType(suggest.type),
  };
}

export function mapCarSuggest(
  suggest: Suggest.CarsSuggest,
): Suggest.Suggest<Suggest.CarsSuggest> {
  return {
    source: suggest,
    title: suggest.name,
    subtitle: suggest.parentName,
    locationType: parseLocationType(suggest.type),
  };
}

export function mapFlightSuggest(
  suggest: SkyscannerPlace,
): Suggest.Suggest<Suggest.FlightSuggest> {
  const iata = suggest.iataCode
    ? suggest.iataCode
    : suggest.airportInformation
    ? suggest.airportInformation.iataCode
    : 'Any';

  return {
    source: { ...suggest, id: iata },
    title: `${suggest.name} (${iata})`,
    subtitle: suggest.countryName,
    locationType: parseLocationTypeSkyscanner(suggest.type),
  };
}

function parseLocationType(location: string | null): Suggest.LocationType {
  switch (location.toLocaleLowerCase()) {
    case 'hotel': {
      return Suggest.LocationType.HOTEL;
    }
    case 'city': {
      return Suggest.LocationType.CITY;
    }
    case 'airport': {
      return Suggest.LocationType.AIRPORT;
    }
    case 'geo': {
      return Suggest.LocationType.POINT;
    }
    case 'station': {
      return Suggest.LocationType.STATION;
    }
    default: {
      return Suggest.LocationType.UNKONWN;
    }
  }
}

function parseLocationTypeSkyscanner(
  location: SkyscannerPlaceType,
): Suggest.LocationType {
  switch (location) {
    case SkyscannerPlaceType.airport: {
      return Suggest.LocationType.AIRPORT;
    }
    case SkyscannerPlaceType.city: {
      return Suggest.LocationType.CITY;
    }
    default: {
      return Suggest.LocationType.UNKONWN;
    }
  }
}
